<template>
  <a-popconfirm
    :cancelText="cancelText"
    :destroyTooltipOnHide="true"
    :okText="okText"
    :okType="okType"
    :placement="placement"
    :getPopupContainer="getContainer"
    ref="popConfirm"
    overlay-class-name="confirm-btn-overlay"
    @cancel="handleCancel"
    @confirm="handleConfirm"
    @visibleChange="handleVisibleChange"
    :overlay-style="overlayStyle"
  >
    <template slot="icon">
      <slot name="icon">
        <m-icon class="pull-left text-warning" name="exclamation-circle" />
      </slot>
    </template>
    <template slot="title">
      <slot name="title">
        <p>Are you sure?</p>
      </slot>
    </template>
    <slot>
      <m-button variant="error">Delete</m-button>
    </slot>
  </a-popconfirm>
</template>

<script>
import Popconfirm from 'ant-design-vue/es/popconfirm'
import 'ant-design-vue/es/popconfirm/style'

export default {
  name: 'MConfirmBtn',
  components: { APopconfirm: Popconfirm },
  data() {
    return {
      lastFocusedElement: null
    }
  },
  props: {
    placement: {
      type: String,
      default: 'rightBottom'
    },
    cancelText: {
      type: String,
      default: 'Cancel'
    },
    okText: {
      type: String,
      default: 'Yes'
    },
    okType: {
      type: String,
      default: 'danger'
    },
    overlayStyle: {
      type: Object
    },
    getPopupContainer: {
      type: Function
    }
  },
  created() {
    const handler = this.hidePopconfirm.bind(this)
    let panels = document.body.querySelectorAll('.__panel')
    for (let i = 0; i < panels.length; i++) {
      panels[i].addEventListener('scroll', handler)
    }
    this.$once('hook:beforeDestroy', function () {
      for (let i = 0; i < panels.length; i++) {
        panels[i].removeEventListener('scroll', handler)
      }
      panels = null
    })
  },
  methods: {
    hidePopconfirm() {
      if (this.$refs.popConfirm.sVisible) {
        this.$refs.popConfirm.setVisible(false)
      }
    },
    getContainer() {
      const element = this.getPopupContainer ? this.getPopupContainer() : null
      if (element) {
        return element
      }
      return document.body
    },
    focusPopoverButtons() {
      this.lastFocusedElement = document.activeElement

      // Delay to ensure popover is rendered
      setTimeout(() => {
        const popover = document.querySelector('.ant-popover')
        if (popover) {
          const buttons = popover.querySelectorAll('button')
          if (buttons.length) {
            buttons[0].focus() // Focus the first button (Yes or No)
          }
        }
      }, 10) // Small delay to ensure popover is rendered
    },

    handleVisibleChange(value) {
      if (value) {
        this.$emit('show')
        this.$nextTick(() => {
          // Delay the focusing to ensure the DOM updates completely
          setTimeout(() => {
            this.focusPopoverButtons()
          }, 10)
        })
      } else {
        this.$emit('hide')
        this.$nextTick(() => {
          if (this.lastFocusedElement) {
            this.lastFocusedElement.focus() // Restore focus to the last element before the popover
          }
        })
      }
    },
    handleConfirm(e) {
      this.$emit('confirm')
    },
    handleCancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>
.ant-popover {
  /* Ensure the popover can hold focus */
  outline: none;
}
</style>
